export const richtextControls = [
  "undoRedo",
  "textFormatting",
  "alignment",
  "link",
  "lists",
  "table",
  "blockFormat",
] as const;

export type RichtextControls = Array<(typeof richtextControls)[number]>;

export const fullRichtextControls = [
  "undoRedo",
  "textFormatting",
  "alignment",
  "link",
  "lists",
  "table",
  "blockFormat",
] as const;

export const tableRichtextControls = [
  "undoRedo",
  "lists",
  "table",
  "textFormatting",
  "link",
] as const;

export const textFormattingRichtextControls = [
  "undoRedo",
  "textFormatting",
] as const;
